import type { DateTime } from 'luxon';
import type { KeysToPascalCase } from './Types';

export const ensureWaitTime = async (start: DateTime, end: DateTime, waitTimeInMS: number): Promise<true> => new Promise((resolve) => {
	const difference = end.diff(start, 'milliseconds').milliseconds;

	if (difference < waitTimeInMS) {
		setTimeout(() => {
			resolve(true);
		}, waitTimeInMS - difference);
	} else {
		resolve(true);
	}
});

export const loadAsyncScript = (src: string, done: () => void) => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.async = true;
	script.src = src;
	script.onload = done;

	const firstScript = document.getElementsByTagName('script')[0];

	if (!firstScript.parentNode) {
		return;
	}

	firstScript.parentNode.insertBefore(script, firstScript);
};

export const isEdgeBrowser = () => {
	if (document.documentMode || /Edge/.test(navigator.userAgent)) {
		return true;
	}

	return false;
};

export const isTrueValue = (value?: string): boolean => {
	if (typeof value !== 'string') {
		return false;
	}

	return value.toLowerCase() === 'true';
};

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const capitalizeObjectKeys = <T extends object>(obj: T): KeysToPascalCase<T> => Object.entries(obj).reduce((newObj, [key, value]) => {
	const capitalizedKey = capitalize(key);

	return {
		...newObj,
		[capitalizedKey]: value,
	};
}, {} as KeysToPascalCase<T>);
